import React from 'react';
import { DataTable } from '@packages/ui/patterns/DataTable';

interface FilterChipsProps {
  filterChips: Array<{ fieldName: string; label: string; displayValue: string }>;
  onRemoveChip: (fieldName: string) => void;
  onClearAll?: () => void;
}

export function FilterChips({ filterChips, onRemoveChip, onClearAll }: FilterChipsProps): JSX.Element | null {
  if (filterChips.length === 0) return null;

  const chips = filterChips.map((chip) => ({
    name: chip.fieldName,
    label: chip.label,
    displayValue: chip.displayValue,
  }));

  return (
    <div className='mb-4' data-testid='dt-v2-filter-chips'>
      <DataTable.FilterChipBar chips={chips} onRemove={onRemoveChip} onClearAll={onClearAll} />
    </div>
  );
}
